import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import RegisterForm from '../../components/auth/RegistrationForm';

const RegisterPage: React.FC = () => {
  const location = useLocation();
  const [referralMessage, setReferralMessage] = useState<string | null>(null);

  useEffect(() => {
    // Check if user came from a referral link
    const referralCode = sessionStorage.getItem('affiliateReferralCode') || (location.state as any)?.referralCode;
    if (referralCode) {
      setReferralMessage('You\'re registering with a referral link! Complete your registration to get started.');
    }
    
    // Also check location state for message
    if ((location.state as any)?.message) {
      setReferralMessage((location.state as any).message);
    }
  }, [location]);

  return (
    <>

      {referralMessage && (
        <div className="auth-form__info-banner" style={{
          backgroundColor: '#e0e7ff',
          color: '#4338ca',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          border: '1px solid #818cf8',
          fontSize: '14px',
          textAlign: 'center'
        }}>
          {referralMessage}
        </div>
      )}
      
      <RegisterForm />
      <div className="auth-form__footer">
        <p className="auth-form__text">
          Already have an account? <Link to="/login" className="auth-form__link">Sign In</Link>
        </p>
      </div>
    </>
  );
};

export default RegisterPage;